import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import InfoIcon from '@mui/icons-material/Info';
import AssignmentIcon from '@mui/icons-material/Assignment';
import App from './App';
import UserList from './userList';
import IconButton from '@mui/material/IconButton';


import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  navigate
} from "react-router-dom";



export const mainListItems = (
  <div>
    <ListItem  button href="https://racce.net">
      <ListItemIcon>
      <IconButton component="a" href="https://racce.net">
        <DashboardIcon />
      </IconButton>
      </ListItemIcon>
      <ListItemText primary="Dashboard" />
    </ListItem>

    <ListItem button href="https://racce.net" >
      <ListItemIcon>
      <IconButton component="a" href="https:racce.net" target="_blank">
        <InfoIcon />
      </IconButton>
      </ListItemIcon>
      <ListItemText href="https://racce.net" primary="Learn More" />
    </ListItem>

  </div>

);

export const secondaryListItems = (
  <div>

    <ListSubheader inset>Saved reports</ListSubheader>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItem>

  </div>
);
